export default __webpack_public_path__ + "static/media/logo_gonemadstudios_white.eb932307.png";